import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, CalendarClock, FileText, Layers, ArrowUpRight } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageIcon } from "@/lib/icons";
import { PageHeader, StatCard, Panel, Empty, StatusBadge } from "@/components/common";

export default function ClientDashboard() {
  const { user, companyName, isViewingAs } = useAuth();
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/portal/dashboard").then((r) => setData(r.data));
  }, []);
  if (!data) return null;
  const { stats } = data;
  return (
    <div>
      <PageHeader eyebrow={companyName} title={isViewingAs ? `Portale di ${companyName}` : `Ciao, ${user.name || "benvenuto"}`} desc="Panoramica dei servizi attivi con Marigot Informatica e dei tuoi documenti." />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
        <StatCard label="Abbonamenti attivi" value={stats.active} icon={CheckCircle2} testid="stat-active" />
        <StatCard label="Rinnovi 60gg" value={stats.expiring} icon={CalendarClock} testid="stat-expiring" delay={60} />
        <StatCard label="Documenti" value={stats.documents} icon={FileText} testid="stat-documents" delay={120} />
        <StatCard label="Servizi totali" value={stats.total} icon={Layers} testid="stat-total" delay={180} />
      </div>
      <div className="grid lg:grid-cols-[1.4fr_1fr] gap-6">
        <div className="grid sm:grid-cols-2 gap-4 content-start">
          {data.pages.map((p, i) => (
            <Link key={p.id} to={`/portale/pagina/${p.id}`} style={{ animationDelay: `${i * 40}ms` }}
              className="fade-up group rounded-lg bg-[#111827] border border-slate-800/80 p-5 hover:border-blue-500/50 transition-colors" data-testid={`dashboard-page-card-${p.slug}`}>
              <div className="flex items-start justify-between">
                <div className="h-10 w-10 rounded-md bg-blue-500/10 border border-blue-500/20 grid place-items-center text-blue-400">
                  <PageIcon name={p.icon} size={18} />
                </div>
                <ArrowUpRight size={16} className="text-slate-600 group-hover:text-blue-400 transition-colors" />
              </div>
              <div className="mt-4 font-medium">{p.title}</div>
              <div className="mt-1 text-xs text-slate-500">
                {p.show_subscriptions && `${p.subscriptions_count} servizi`}
                {p.show_subscriptions && p.show_documents && " · "}
                {p.show_documents && `${p.documents_count} documenti`}
              </div>
            </Link>
          ))}
        </div>
        <Panel title="Prossimi rinnovi" testid="upcoming-renewals">
          {data.upcoming.length ? (
            <ul className="divide-y divide-slate-800">
              {data.upcoming.map((s) => (
                <li key={s.id} className="px-5 py-3 flex items-center justify-between gap-3">
                  <div className="min-w-0">
                    <div className="text-sm font-medium truncate">{s.service_name}</div>
                    <div className="text-xs text-slate-500">Rinnovo {fmtDate(s.renewal_date)}</div>
                  </div>
                  <StatusBadge status={s.status} />
                </li>
              ))}
            </ul>
          ) : <Empty text="Nessun rinnovo nei prossimi 60 giorni." />}
        </Panel>
      </div>
    </div>
  );
}
